import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../shared/makeApiCall";
import { useToast } from "../../contexts/ToastContext";

import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function QuickbooksCallbackViewModel(logout) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });


  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const onStartCallback = async function (params) {
    // params can be an object like { code, state, realmId }
    setLoading(true);
    let callResult;

    callResult = await makePostApiCall(`quickbooks/callback`, params);
    console.log("quickbooks callback result", callResult);
    setLoading(false);
    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Quickbooks Connected"
      );
      return true;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(
        "Could not Finish Quickbooks Connection",
        callResult.message
      );
      return false;
    }
  };

  return {
    emptyModal,
    setEmptyModelOpen,
    onStartCallback,
  };
}
